module.exports = require("@jswork/next-offline-sw");